import React, { Component } from 'react'

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta"></span>
                <h2 className="colorlib-heading animate-box">Timeline</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-1">
                        <i className="icon-briefcase" />
                      </div>
                      <div className="timeline-label">
                        <h2>Full Stack Engineer - Cisco Meraki <span>December 2024 - Present</span></h2>
                          <ul>
                            <li>Build full-stack features across the Cisco Meraki Dashboard — a platform serving 500,000+ organizations — using React, TypeScript and CSS on the front-end and Ruby on Rails on the backend.</li>
                            <li>Develop object-oriented Scala device-grabber services, running on Kubernetes, that continuously collect state from millions of switches into Postgres/SQLite, with Snowflake for fleet-wide analysis.</li>
                            <li>Rebuilt the switching product’s Client Tracking & Traffic Analytics from severely buggy to fully functional, closing 20+ bugs.</li>
                            <li>Develop switch-configuration systems that apply dashboard changes as NETCONF transactions across millions of deployed switches.</li>
                            <li>Work in an agile team — serve as Scrum Master, collaborating through Git code review and Jira.</li>
                          </ul>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-2">
                        <i className="icon-briefcase" />
                      </div>
                      <div className="timeline-label">
                        <h2>Firmware Engineer - Cisco Meraki <span>January 2023 - December 2024</span></h2>
                          <ul>
                            <li>Debugged and resolved firmware issues across Linux-based switch products in C/C++, coordinating daily with an eight-person team.</li>
                            <li>Established and managed three test labs for switch debugging, accelerating defect isolation by 30%.</li>
                            <li>Contributed to the rollout of a new firmware architecture to 1M+ devices with minimal customer disruption.</li>
                          </ul>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Queen's University - Mathematics and Engineering: Computing and Communications <span>Graduated 2022</span></h2>
                        <p>Bachelor of Applied Science - BASc, Mathematics and Engineering, Computing and Communications. MATLAB-intensive capstone and coursework.
                           For my cumulative project, I performed an adjoint shape analysis in OpenFOAM on the rear wing of the Queen's Formula SAE car —
                           running thousands of wing modifications in C++ and Bash to find shapes that increased downforce with minimal drag penalty.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-briefcase" />
                      </div>
                      <div className="timeline-label">
                        <h2>Data Analytics Co-op - Fasken Martineau DuMoulin LLP <span>Summer 2022</span></h2>
                          <ul>
                            <li>Built SQL databases and Power BI dashboards that replaced manual data collection, saving the team 20 hours per month.</li>
                            <li>Automated recurring reporting with Python, Power Automate and Azure Functions.</li>
                            <li>Created Python tools for staff to automatically adjust and clean Excel files for lawyer consumption.</li>
                          </ul>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-1">
                        <i className="icon-briefcase" />
                      </div>
                      <div className="timeline-label">
                        <h2>Embedded Software Engineering Intern - Cisco Meraki <span>May 2020 - August 2021</span></h2>
                          <ul>
                            <li>Worked with Meraki’s Platform and Hardware teams on firmware for several Linux-kernel based products (C/C++, Device Tree).</li>
                            <li>Platform bring up using Yocto and OpenWRT – SoC, PHYs, memory, other peripherals (Make).</li>
                            <li>Bootloader Development (U-boot).</li>
                            <li>Embedded software for BLE, LTE, GPS communication (C/C++).</li>
                            <li>Built custom drivers for NPI IoT sensors on Meraki’s new MT product line (C).</li>
                            <li>Worked with vendors such as Qualcomm and Marvell to validate the compatibility of SoCs for upcoming Meraki products.</li>
                          </ul>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-book2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Queen's Mostly Autonomous Sailboat Team - Queen's University <span>2017-2020</span></h2>
                          <ul>
                            <li>As Head Manager, led the software, electrical, and mechanical teams building an autonomous sailboat — coordinating timelines, delegating work, and tracking progress to competition deadlines.</li>
                            <li>Wrote Python sailing logic on Arduino to trim sails and steer from live wind direction, and built a React Native / Node.js app to control servos and monitor boat status.</li>
                          </ul>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
